module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/game-state/ticker-speed/ticker-speed.component.css
// module id = ./src/app/web/game/game-state/ticker-speed/ticker-speed.component.css
// module chunks = main